import { render, staticRenderFns } from "./SuggestTicket.vue?vue&type=template&id=308863ca&"
import script from "./SuggestTicket.vue?vue&type=script&lang=js&"
export * from "./SuggestTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports